import { render } from "./IconSearch.vue?vue&type=template&id=9ac04cd2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ac04cd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ac04cd2', __exports__)) {
    api.reload('9ac04cd2', __exports__)
  }
  
  module.hot.accept("./IconSearch.vue?vue&type=template&id=9ac04cd2", () => {
    api.rerender('9ac04cd2', render)
  })

}


export default __exports__